import styled, { css } from 'styled-components'
import { colors, device } from '../../../styles/GlobalVariables'
import { globalStyles } from '../../ottGlobalStyles'
import { PlayerDiv } from '../Player/Player.style'
import { Container } from '../../../components/Ads/TopBanner/TopBanner.styles'
import { mediaCdn } from '../../../components/Player/Helpers'

export const CatchupPlayerContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${props => {
    if (props.theme.isCatchup) {
      return css`
        background-color: black;
      `
    }
    return css`
      ${device.small} {
        min-height: 120vh;
        background-size: contain;
        background-position: top;
        background-repeat: no-repeat;
      }
    `
  }}
`

export const BannerWrapper = styled.div`
  ${device.medium} {
    display: flex;
    height: auto;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    background: transparent;

    ${Container} {
      background: transparent;
      border-bottom: none;
    }
  }

  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-top: 5px;
  background: #1e1e1e;
  position: relative;
  bottom: 5px;
`
export const LeftColumn = styled.div<{ isMobile: boolean }>`
  ${device.medium} {
    display: flex;

    flex-direction: column;

    gap: 95px;
    width: 100%;
    &:after {
      content: '';
      position: relative;
      margin: 0 auto;
      width: 320px;
      height: 4px;
      background-image: url(${mediaCdn}v1742385545/uploads/2025/904509791.png);
      background-size: cover;
      background-repeat: round;
    }
  }

  display: none;
`

export const LeftRailItem = styled.div`
  ${device.medium} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    height: 266px;
    width: 300px;
  }

  display: none;
`

export const LeftRailItemSeparator = styled.img`
  display: block;
  width: 100%;
  height: 4px;
  margin-top: 115px;
`
export const LeftRailItemImage = styled.img`
  width: 300px;
  height: 170px;
  border-radius: 10px;
`

export const LeftRailItemTitleCreditContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LeftRailItemTitle = styled.div`
  color: rgba(255, 255, 255, 0.7);
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.4px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`

export const LeftRailItemCredit = styled.div`
  color: rgba(255, 255, 255, 0.5);
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.36px;
`

export const DynamicColumnsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  grid-template-columns: 1fr;
  align-items: start;

  ${device.medium} {
    width: 100vw;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    gap: 40px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`
export const MainWrapper = styled.div`
  position: relative;
`
export const PlayerWrapper = styled.div`
  ${device.medium} {
    display: flex;
    flex-direction: column;
    align-self: start;
    width: 70dvw;
    //width: 1348px;
    background: #000;

    ${PlayerDiv} {
      min-height: 100px;
      max-height: calc(1128px * 9 / 16);
      max-width: 1128px;
    }

    .playkit-player .playkit-seek-bar .playkit-progress-bar .playkit-progress {
      background: #fff;
      margin: 0 auto;
      width: 80vw;
    }
  }
`
export const CatchupProgramSeries = styled.div`
  ${device.small} {
    div[class*='EpisodeListItemThumbnail'] {
      //margin-right: 0;
    }
  }

  margin-top: 30px;
`
export const CatchupDetailsWrapper = styled.div`
  position: relative;
  z-index: 1;
  background-color: ${props =>
    props.theme.isCatchup ? colors.ottBlue : 'transparent'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  color: #fff;
  padding: 0 ${globalStyles.gridPadding.mobile};
  gap: 8px;

  ${device.small} {
    padding: 15px 6vw 0;
  }

  @media only screen and (max-width: 768px) {
    padding-top: 9vw;
  }
`
export const CatchupPageTitle = styled.div`
  opacity: 0.5;
  text-align: right;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.72px;
  display: none;

  ${device.small} {
    display: initial;
  }
`
export const CatchupAssetTitle = styled.h1`
  width: 100%;
  color: #fff;
  text-align: right;
  text-shadow: 0 4px 40px rgba(255, 255, 255, 0.25);
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px; /* 106.25% */
  letter-spacing: -1.28px;
  margin: 0;

  ${device.small} {
    text-align: right;
    text-shadow: 0 4px 60px rgba(255, 255, 255, 0.15);
    font-size: 40px;
    line-height: 94%; /* 56.4px */
    letter-spacing: -1.2px;
  }
`
export const CatchupAssetDescription = styled.h2`
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.6px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${device.small} {
    font-size: 20px;
    letter-spacing: -0.6px;
  }
  @media only screen and (max-width: 768px) {
    text-align: right;
  }
`
export const ShowMoreButton = styled.div`
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: center;
  gap: 4px;
  border-radius: 65px;
  border: 1px solid #fff;
  background: #fff;
  width: 110px;
  height: 34px;
  margin: 0 auto 50px auto;
  cursor: pointer;
`

export const ShowMoreButtonText = styled.div`
  display: flex;
  width: 54px;
  height: 22px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.54px;
  align-self: center;
`

export const CatchupDateTime = styled.div`
  width: 100%;
  opacity: 0.5;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.6px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  margin-bottom: 10.5vw;

  justify-content: center;

  ${device.small} {
    margin-bottom: 40px;
    justify-content: flex-start;
    font-size: 22px;
    font-weight: 300;
    letter-spacing: -0.66px;
  }
`
export const CatchupTime = styled.div``
export const CatchupDate = styled.div``
